import { render, staticRenderFns } from "./OffersListSimplified.vue?vue&type=template&id=1b2ab5b5&"
import script from "./OffersListSimplified.vue?vue&type=script&lang=js&"
export * from "./OffersListSimplified.vue?vue&type=script&lang=js&"
import style0 from "./OffersListSimplified.vue?vue&type=style&index=0&id=1b2ab5b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports